import React, { useState } from "react";
import OffenseDefenseTable from "./OffenseDefenseTable";
import TeamStatsTable from "./TeamStatsTable";
import GoalsBreakdownTable from "./GoalsBreakdownTable";

const FootballLeagueTeamStats = ({ data }) => {
  const [activeOff, setActiveOff] = useState("offense");
  const [activeTeamStats, setActiveTeamStats] = useState("goals");
  const [activeGoal, setActiveGoal] = useState("scored");

  return (
    <>
      <OffenseDefenseTable
        data={data}
        active={activeOff}
        setActive={setActiveOff}
      />
      <TeamStatsTable
        data={data}
        active={activeTeamStats}
        setActive={setActiveTeamStats}
      />
      <GoalsBreakdownTable
        data={data}
        active={activeGoal}
        setActive={setActiveGoal}
      />
    </>
  );
};

export default FootballLeagueTeamStats;
